var _rect, _rect2, _rect3, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 6.25,
    width: 11.5,
    height: 0.5,
    rx: 0.25,
    stroke: "#7D899D",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 12.25,
    width: 6.5,
    height: 0.5,
    rx: 0.25,
    stroke: "#7D899D",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 9.25,
    width: 8.5,
    height: 0.5,
    rx: 0.25,
    stroke: "#7D899D",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.1192C10.5 19.6325 11.5809 18.3664 13.0493 18.1334L16.2945 17.6182C16.7619 17.544 17.2381 17.544 17.7055 17.6182L20.9507 18.1334C22.4191 18.3664 23.5 19.6325 23.5 21.1192C23.5 21.3295 23.3295 21.5 23.1192 21.5H10.8808C10.6705 21.5 10.5 21.3295 10.5 21.1192Z",
    stroke: "#7D899D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15C2 16.1046 2.89543 17 4 17H10.8238C10.6591 16.6836 10.5197 16.349 10.4086 15.9996H3.89844C3.34615 15.9996 2.89844 15.5518 2.89844 14.9996L2.89844 3.99956C2.89844 3.44728 3.34615 2.99956 3.89844 2.99956L18.0984 2.99956C18.6507 2.99956 19.0984 3.44728 19.0984 3.99956V8.34184C19.4134 8.46553 19.7149 8.62077 20 8.80413V4C20 2.89543 19.1046 2 18 2H4C2.89543 2 2 2.89543 2 4V15Z",
    fill: "#7D899D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 2.5,
    stroke: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.64be531bf65adc2db3c37250319c1187.svg";
export { ForwardRef as ReactComponent };